import LocalStorageService from "../services/localStorage";
import { Steps } from "../enum/steps";
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
export var getCustomerAction = function () {
    var customerAuto = ["apap-auto", "bancounion", "fdd"];
    return {
        customerAuto: customerAuto,
    };
};
export var isApapAuto = function (subdomain) {
    return getCustomerAction().customerAuto.includes(subdomain);
};
export var isAlnap = function (subdomain) {
    return ["alnap-subdomain"].includes(subdomain);
};
export var isAcap = function (subdomain) {
    return ["acap-subdomain"].includes(subdomain);
};
export var isCustomer = function (customer) {
    var _a, _b, _c, _d;
    var result = ((_d = (_c = (_b = (_a = localStorageService.getStepStored().steps[Steps.insurance]) === null || _a === void 0 ? void 0 : _a.flow) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.productType) === customer
        ? true
        : false;
    return result;
};
